import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { PersitedDatePicker } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';
import axios from 'axios';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {
  top20PartWise,
  getAllPartWise,
} from '../../../helpers/getDashBoardData';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
);

interface IProps {
  apiData: any;
  allPart?: any;
}

const BarChart = ({ apiData, allPart }: IProps) => {
  const options = {
    plugins: {
      maintainAspectRatio: false,
      title: {
        // display: true,
        // text: allPart ? 'PART REJECTION TREND' : 'Top 20 PART REJECTION TREND',
      },
    },
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: 'Parts',
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 2,
        },
        title: {
          display: true,
          text: 'Parts Qty.',
        },
      },
    },
  };
  const backgroundColors = ['#4c6ef5'];
  const datasets = [
    {
      label: 'Parts Qty.',
      data: allPart
        ? getAllPartWise(apiData).map((item) => item.rejectionCount)
        : top20PartWise(apiData).map((item) => item.rejectionCount),
      backgroundColor: backgroundColors,
      borderWidth: 1,
      barThickness: 50,
    },
  ];
  const data = {
    labels: allPart
      ? getAllPartWise(apiData).map((item) => item.PartName)
      : top20PartWise(apiData).map((item) => item.PartName),
    datasets: datasets,
  };
  return (
    <div>
        <Bar options={options} data={data} />;
    </div>
  );
};

export default BarChart;
